import YouTubePlayer from "youtube-player";
import { ScrollLock } from "../../utility/_scrollLock";

document.addEventListener("DOMContentLoaded", () => {
  const thumbnail = document.getElementById("profileYoutubeThumnail");
  const modal = document.getElementById("profileYoutubeModal");
  const closeButton = modal.querySelector(".modal__close");
  const scrollLock = new ScrollLock(); // ScrollLock インスタンスを作成
  let player;

  // YouTube Playerの準備
  function onYouTubeIframeAPIReady() {
    player = new YT.Player("profileYoutubeModalMovie", {
      videoId: "rH33lR6TXYo",
      playerVars: { autoplay: 1, controls: 1 },
      events: {
        onReady: (event) => {
          event.target.pauseVideo();
        },
      },
    });
  }

  // モーダルを開く
  thumbnail.addEventListener("click", () => {
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    scrollLock.activate(); // スクロールをロック
    if (player && typeof player.playVideo === "function") {
      player.playVideo();
    }
  });

  // モーダルを閉じる
  closeButton.addEventListener("click", () => {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    scrollLock.deactivate(); // スクロールロックを解除
    if (player && typeof player.pauseVideo === "function") {
      player.pauseVideo();
    }
  });

  // YouTube IFrame APIをロード
  var tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
});
